import { CALL_API } from 'middlewares/api';
import { url } from 'configs';
import { buildPageMeta } from 'containers/App/screens/Tube/utils';

const { NEWTUBE_API_SERVER } = url;

import {
  downloadFile,
} from 'containers/App/screens/Tube/utils/downloadFile';

const FETCH_SHOPSEARCH_REQUEST = 'tube/orders/index/FETCH_SHOPSEARCH_REQUEST';
const FETCH_SHOPSEARCH_SUCCESS = 'tube/orders/index/FETCH_SHOPSEARCH_SUCCESS';
const FETCH_SHOPSEARCH_ERROR = 'tube/orders/index/FETCH_SHOPSEARCH_ERROR';

const FETCH_SHOPCATEGORY_REQUEST = 'tube/orders/index/FETCH_SHOPCATEGORY_REQUEST';
const FETCH_SHOPCATEGORY_SUCCESS = 'tube/orders/index/FETCH_SHOPCATEGORY_SUCCESS';
const FETCH_SHOPCATEGORY_ERROR = 'tube/orders/index/FETCH_SHOPCATEGORY_ERROR';

const FETCH_COUNTRY_REQUEST = 'tube/orders/index/FETCH_COUNTRY_REQUEST';
const FETCH_COUNTRY_SUCCESS = 'tube/orders/index/FETCH_COUNTRY_SUCCESS';
const FETCH_COUNTRY_ERROR = 'tube/orders/index/FETCH_COUNTRY_ERROR';

const FETCH_COUNTY_REQUEST = 'tube/orders/index/FETCH_COUNTY_REQUEST';
const FETCH_COUNTY_SUCCESS = 'tube/orders/index/FETCH_COUNTY_SUCCESS';
const FETCH_COUNTY_ERROR = 'tube/orders/index/FETCH_COUNTY_ERROR';

const FETCH_CITYAREA_REQUEST = 'tube/orders/index/FETCH_CITYAREA_REQUEST';
const FETCH_CITYAREA_SUCCESS = 'tube/orders/index/FETCH_CITYAREA_SUCCESS';
const FETCH_CITYAREA_ERROR = 'tube/orders/index/FETCH_CITYAREA_ERROR';

const FETCH_CLOSEDATA_REQUEST = 'tube/orders/index/FETCH_CLOSEDATA_REQUEST';
const FETCH_CLOSEDATA_SUCCESS = 'tube/orders/index/FETCH_CLOSEDATA_SUCCESS';
const FETCH_CLOSEDATA_ERROR = 'tube/orders/index/FETCH_CLOSEDATA_ERROR';

const FETCH_EVALUATIONDATA_REQUEST = 'tube/orders/index/FETCH_EVALUATIONDATA_REQUEST';
const FETCH_EVALUATIONDATA_SUCCESS = 'tube/orders/index/FETCH_EVALUATIONDATA_SUCCESS';
const FETCH_EVALUATIONDATA_ERROR = 'tube/orders/index/FETCH_EVALUATIONDATA_ERROR';

const FETCH_ORDEREDITDATA_REQUEST = 'tube/orders/index/FETCH_ORDEREDITDATA_REQUEST';
const FETCH_ORDEREDITDATA_SUCCESS = 'tube/orders/index/FETCH_ORDEREDITDATA_SUCCESS';
const FETCH_ORDEREDITDATA_ERROR = 'tube/orders/index/FETCH_ORDEREDITDATA_ERROR';

const POST_EVALUATIONDATA_REQUEST = 'tube/orders/index/POST_EVALUATIONDATA_REQUEST';
const POST_EVALUATIONDATA_SUCCESS = 'tube/orders/index/POST_EVALUATIONDATA_SUCCESS';
const POST_EVALUATIONDATA_ERROR = 'tube/orders/index/POST_EVALUATIONDATA_ERROR';

const POST_ORDER_REQUEST = 'tube/orders/index/POST_ORDER_REQUEST';
const POST_ORDER_SUCCESS = 'tube/orders/index/POST_ORDER_SUCCESS';
const POST_ORDER_ERROR = 'tube/orders/index/POST_ORDER_ERROR';

const POST_ORDERMESSAGE_REQUEST = 'tube/orders/index/POST_ORDERMESSAGE_REQUEST';
const POST_ORDERMESSAGE_SUCCESS = 'tube/orders/index/POST_ORDERMESSAGE_SUCCESS';
const POST_ORDERMESSAGE_ERROR = 'tube/orders/index/POST_ORDERMESSAGE_ERROR';

const POST_ORDERMESSAGE_STICKY_REQUEST = 'tube/orders/index/POST_ORDERMESSAGE_STICKY_REQUEST';
const POST_ORDERMESSAGE_STICKY_SUCCESS = 'tube/orders/index/POST_ORDERMESSAGE_STICKY_SUCCESS';
const POST_ORDERMESSAGE_STICKY_ERROR = 'tube/orders/index/POST_ORDERMESSAGE_STICKY_ERROR';

const PUT_ORDEREDITDATA_REQUEST = 'tube/orders/index/PUT_ORDEREDITDATA_REQUEST';
const PUT_ORDEREDITDATA_SUCCESS = 'tube/orders/index/PUT_ORDEREDITDATA_SUCCESS';
const PUT_ORDEREDITDATA_ERROR = 'tube/orders/index/PUT_ORDEREDITDATA_ERROR';

const PUT_ORDERDATA_REQUEST = 'tube/orders/index/PUT_ORDERDATA_REQUEST';
const PUT_ORDERDATA_SUCCESS = 'tube/orders/index/PUT_ORDERDATA_SUCCESS';
const PUT_ORDERDATA_ERROR = 'tube/orders/index/PUT_ORDERDATA_ERROR';

const FETCH_LIMIT_EMPLOYEES_REQUEST = 'tube/orders/index/FETCH_LIMIT_EMPLOYEES_REQUEST';
const FETCH_LIMIT_EMPLOYEES_SUCCESS = 'tube/orders/index/FETCH_LIMIT_EMPLOYEES_SUCCESS';
const FETCH_LIMIT_EMPLOYEES_ERROR = 'tube/orders/index/FETCH_LIMIT_EMPLOYEES_ERROR';

const POST_ORDERCANCEL_REQUEST = 'tube/orders/index/POST_ORDERCANCEL_REQUEST';
const POST_ORDERCANCEL_SUCCESS = 'tube/orders/index/POST_ORDERCANCEL_SUCCESS';
const POST_ORDERCANCEL_ERROR = 'tube/orders/index/POST_ORDERCANCEL_ERROR';

const POST_ORDERPASS_REQUEST = 'tube/orders/index/POST_ORDERPASS_REQUEST';
const POST_ORDERPASS_SUCCESS = 'tube/orders/index/POST_ORDERPASS_SUCCESS';
const POST_ORDERPASS_ERROR = 'tube/orders/index/POST_ORDERPASS_ERROR';

const DELETE_ORDERDATA_REQUEST = 'tube/orders/index/DELETE_ORDERDATA_REQUEST';
const DELETE_ORDERDATA_SUCCESS = 'tube/orders/index/DELETE_ORDERDATA_SUCCESS';
const DELETE_ORDERDATA_ERROR = 'tube/orders/index/DELETE_ORDERDATA_ERROR';

const GET_DOWNLOADEXCEL_PAIDTOTAL_REQUEST = 'tube/orders/index/GET_DOWNLOADEXCEL_PAIDTOTAL_REQUEST';
const GET_DOWNLOADEXCEL_PAIDTOTAL_SUCCESS = 'tube/orders/index/GET_DOWNLOADEXCEL_PAIDTOTAL_SUCCESS';
const GET_DOWNLOADEXCEL_PAIDTOTAL_ERROR = 'tube/orders/index/GET_DOWNLOADEXCEL_PAIDTOTAL_ERROR';

const GET_DOWNLOADEXCEL_PAID_REQUEST = 'tube/orders/index/GET_DOWNLOADEXCEL_PAID_REQUEST';
const GET_DOWNLOADEXCEL_PAID_SUCCESS = 'tube/orders/index/GET_DOWNLOADEXCEL_PAID_SUCCESS';
const GET_DOWNLOADEXCEL_PAID_ERROR = 'tube/orders/index/GET_DOWNLOADEXCEL_PAID_ERROR';

const PUT_RECEIVABLESNOTE_REQUEST = 'tube/orders/index/PUT_RECEIVABLESNOTE_REQUEST';
const PUT_RECEIVABLESNOTE_SUCCESS = 'tube/orders/index/PUT_RECEIVABLESNOTE_SUCCESS';
const PUT_RECEIVABLESNOTE_ERROR = 'tube/orders/index/PUT_RECEIVABLESNOTE_ERROR';

const PUT_ORDERISPAY_REQUEST = 'tube/orders/index/PUT_ORDERISPAY_REQUEST';
const PUT_ORDERISPAY_SUCCESS = 'tube/orders/index/PUT_ORDERISPAY_SUCCESS';
const PUT_ORDERISPAY_ERROR = 'tube/orders/index/PUT_ORDERISPAY_ERROR';

const PUT_ORDERCANCEL_REQUEST = 'tube/orders/index/PUT_ORDERCANCEL_REQUEST';
const PUT_ORDERCANCEL_SUCCESS = 'tube/orders/index/PUT_ORDERCANCEL_SUCCESS';
const PUT_ORDERCANCEL_ERROR = 'tube/orders/index/PUT_ORDERCANCEL_ERROR';

export default function reducer(state = {
  editData: {
    isLoadingEdit: false,
    data: [],
  },
  closedData: {
    isLoadingClosed: false,
    data: [],
  },
  evaluationData: {
    isLoadingEvaluation: false,
    data: [],
  },
  shop: {
    isLoadingShop: false,
    data: [],
  },
  category: {
    isLoadingCategory: false,
    data: [],
  },
  country: {
    isLoadingCountry: false,
    data: [],
  },
  purchase: {
    isPurchaseCancelLoading: false,
    isPurchasePassLoading: false,
    isPurchaseConfirmLoading: false,
  },
  editDataMeta: {},
  closedDataMeta: {},
  evaluationDataMeta: {},
  shopMeta: {},
  categoryMeta: {},
  countryMeta: {},
}, action) {
  switch (action.type) {
    case FETCH_ORDEREDITDATA_REQUEST:
      return Object.assign({}, state, {
        editData: {
          isLoadingEdit: true,
        },
      });
    case FETCH_ORDEREDITDATA_SUCCESS:
      return Object.assign({}, state, {
        editData: {
          isLoadingEdit: false,
          data: action.response.data,
        },
        editDataMeta: buildPageMeta(action.response.meta),
      });
    case FETCH_CLOSEDATA_REQUEST:
      return Object.assign({}, state, {
        closedData: {
          isLoadingClosed: true,
        },
      });
    case FETCH_CLOSEDATA_SUCCESS:
      return Object.assign({}, state, {
        closedData: {
          isLoadingClosed: false,
          data: action.response.data,
        },
        closedDataMeta: buildPageMeta(action.response.meta),
      });
    case FETCH_EVALUATIONDATA_REQUEST:
      return Object.assign({}, state, {
        evaluationData: {
          isLoadingEvaluation: true,
        },
      });
    case FETCH_EVALUATIONDATA_SUCCESS:
      return Object.assign({}, state, {
        evaluationData: {
          isLoadingEvaluation: false,
          data: action.response.data,
        },
        evaluationDataMeta: buildPageMeta(action.response.meta),
      });
    case FETCH_SHOPSEARCH_REQUEST:
      return Object.assign({}, state, {
        shop: {
          isLoadingShop: true,
        },
      });
    case FETCH_SHOPSEARCH_SUCCESS:
      return Object.assign({}, state, {
        shop: {
          isLoadingShop: false,
          data: action.response.data,
        },
        shopMeta: buildPageMeta(action.response.meta),
      });
    case FETCH_SHOPCATEGORY_REQUEST:
      return Object.assign({}, state, {
        category: {
          isLoadingCategory: true,
        },
      });
    case FETCH_SHOPCATEGORY_SUCCESS:
      return Object.assign({}, state, {
        category: {
          isLoadingCategory: false,
          data: action.response.data,
        },
        categoryMeta: buildPageMeta(action.response.meta),
      });
    case FETCH_COUNTRY_REQUEST:
      return Object.assign({}, state, {
        country: {
          isLoadingCountry: true,
        },
      });
    case FETCH_COUNTRY_SUCCESS:
      return Object.assign({}, state, {
        country: {
          isLoadingCountry: false,
          data: action.response.data,
        },
        countryMeta: buildPageMeta(action.response.meta),
      });
    case PUT_ORDERDATA_REQUEST:
      return Object.assign({}, state, {
        purchase: {
          isPurchaseConfirmLoading: true,
        },
      });
    case PUT_ORDERDATA_SUCCESS:
      return Object.assign({}, state, {
        purchase: {
          isPurchaseConfirmLoading: false,
        },
      });
    case PUT_ORDERDATA_ERROR:
      return Object.assign({}, state, {
        purchase: {
          isPurchaseConfirmLoading: false,
        },
      });
    case POST_ORDERCANCEL_REQUEST:
      return Object.assign({}, state, {
        purchase: {
          isPurchaseCancelLoading: true,
        },
      });
    case POST_ORDERCANCEL_SUCCESS:
      return Object.assign({}, state, {
        purchase: {
          isPurchaseCancelLoading: false,
        },
      });
    case POST_ORDERCANCEL_ERROR:
      return Object.assign({}, state, {
        purchase: {
          isPurchaseCancelLoading: false,
        },
      });
    case POST_ORDERPASS_REQUEST:
      return Object.assign({}, state, {
        purchase: {
          isPurchasePassLoading: true,
        },
      });
    case POST_ORDERPASS_SUCCESS:
      return Object.assign({}, state, {
        purchase: {
          isPurchasePassLoading: false,
        },
      });
    case POST_ORDERPASS_ERROR:
      return Object.assign({}, state, {
        purchase: {
          isPurchasePassLoading: false,
        },
      });
    default:
      return state;
  }
}

// 新增訂單
export function postOrder(orderData, functionCode) {
  return {
    [CALL_API]: {
      url: NEWTUBE_API_SERVER + 'Ordering',
      method: 'POST',
      headers: {
        functionCode,
        actionCode: 'Manage',
      },
      types: [
        POST_ORDER_REQUEST,
        POST_ORDER_SUCCESS,
        POST_ORDER_ERROR,
      ],
      params: orderData,
    },
  };
}

// 搜尋店家
export function fetchShopSearch(paramsData, functionCode) {
  return {
    [CALL_API]: {
      url: NEWTUBE_API_SERVER + 'Ordering/ShopSearch',
      method: 'GET',
      headers: {
        functionCode,
        actionCode: 'Default',
      },
      types: [
        FETCH_SHOPSEARCH_REQUEST,
        FETCH_SHOPSEARCH_SUCCESS,
        FETCH_SHOPSEARCH_ERROR,
      ],
      params: paramsData,
    },
  };
}

// 分類
export function fetchShopCategory() {
  return {
    [CALL_API]: {
      url: NEWTUBE_API_SERVER + 'Ordering/Category',
      method: 'GET',
      types: [
        FETCH_SHOPCATEGORY_REQUEST,
        FETCH_SHOPCATEGORY_SUCCESS,
        FETCH_SHOPCATEGORY_ERROR,
      ],
    },
  };
}

// 國家
export function fetchCountry() {
  return {
    [CALL_API]: {
      url: NEWTUBE_API_SERVER + 'Ordering/Country',
      method: 'GET',
      types: [
        FETCH_COUNTRY_REQUEST,
        FETCH_COUNTRY_SUCCESS,
        FETCH_COUNTRY_ERROR,
      ],
    },
  };
}

// 城市
export function fetchCounty(countryId) {
  return {
    [CALL_API]: {
      url: NEWTUBE_API_SERVER + 'Ordering/County?CountryId=' + countryId,
      method: 'GET',
      types: [
        FETCH_COUNTY_REQUEST,
        FETCH_COUNTY_SUCCESS,
        FETCH_COUNTY_ERROR,
      ],
    },
  };
}

// 鄉鎮
export function fetchCityArea(countyId) {
  return {
    [CALL_API]: {
      url: NEWTUBE_API_SERVER + 'Ordering/CityArea?CountyId=' + countyId,
      method: 'GET',
      types: [
        FETCH_CITYAREA_REQUEST,
        FETCH_CITYAREA_SUCCESS,
        FETCH_CITYAREA_ERROR,
      ],
    },
  };
}

// 結案資料
export function fetchClosedData() {
  return {
    [CALL_API]: {
      url: NEWTUBE_API_SERVER + 'Ordering/Management/Closed',
      method: 'GET',
      headers: {
        functionCode: 'OrderEmp',
        actionCode: 'Manage',
      },
      types: [
        FETCH_CLOSEDATA_REQUEST,
        FETCH_CLOSEDATA_SUCCESS,
        FETCH_CLOSEDATA_ERROR,
      ],
    },
  };
}

// 評價資料
export function fetchEvaluationData() {
  return {
    [CALL_API]: {
      url: NEWTUBE_API_SERVER + 'Ordering/Evaluation',
      method: 'GET',
      headers: {
        functionCode: 'OrderEmp',
        actionCode: 'default',
      },
      types: [
        FETCH_EVALUATIONDATA_REQUEST,
        FETCH_EVALUATIONDATA_SUCCESS,
        FETCH_EVALUATIONDATA_ERROR,
      ],
    },
  };
}

// 評價資料送出
export function postEvaluationData(data, orderingId) {
  return {
    [CALL_API]: {
      url: NEWTUBE_API_SERVER + 'Ordering/Evaluation/' + orderingId,
      method: 'POST',
      headers: {
        functionCode: 'OrderEmp',
        actionCode: 'default',
      },
      types: [
        POST_EVALUATIONDATA_REQUEST,
        POST_EVALUATIONDATA_SUCCESS,
        POST_EVALUATIONDATA_ERROR,
      ],
      params: data,
    },
  };
}

// 取得單筆訂單
export function fetchOrderEditData(OrderingId) {
  return {
    [CALL_API]: {
      url: NEWTUBE_API_SERVER + 'Ordering/Management/Edit/' + OrderingId,
      method: 'GET',
      headers: {
        functionCode: 'OrderEmp',
        actionCode: 'Manage',
      },
      types: [
        FETCH_ORDEREDITDATA_REQUEST,
        FETCH_ORDEREDITDATA_SUCCESS,
        FETCH_ORDEREDITDATA_ERROR,
      ],
    },
  };
}

// 修改訂購 - 發佈訊息
export function postOrderMessage(messageData, OrderingId) {
  return {
    [CALL_API]: {
      url: NEWTUBE_API_SERVER + 'Ordering/Management/Notice/' + OrderingId,
      method: 'POST',
      headers: {
        functionCode: 'OrderEmp',
        actionCode: 'Manage',
      },
      types: [
        POST_ORDERMESSAGE_REQUEST,
        POST_ORDERMESSAGE_SUCCESS,
        POST_ORDERMESSAGE_ERROR,
      ],
      params: {
        message: messageData,
      },
    },
  };
}

// 修改訂購 - 發佈訊息&發佈便利貼
export function postOrderMessageSticky(messageData, OrderingId) {
  return {
    [CALL_API]: {
      url: NEWTUBE_API_SERVER + 'Ordering/Management/Notice/' + OrderingId + '/Sticky',
      method: 'POST',
      headers: {
        functionCode: 'OrderEmp',
        actionCode: 'Manage',
      },
      types: [
        POST_ORDERMESSAGE_STICKY_REQUEST,
        POST_ORDERMESSAGE_STICKY_SUCCESS,
        POST_ORDERMESSAGE_STICKY_ERROR,
      ],
      params: {
        message: messageData,
      },
    },
  };
}

// 編輯訂單送出
export function putOrderEditData(editData, OrderingId) {
  return {
    [CALL_API]: {
      url: NEWTUBE_API_SERVER + 'Ordering/Management/Edit/' + OrderingId,
      method: 'PUT',
      headers: {
        functionCode: 'OrderEmp',
        actionCode: 'Manage',
      },
      types: [
        PUT_ORDEREDITDATA_REQUEST,
        PUT_ORDEREDITDATA_SUCCESS,
        PUT_ORDEREDITDATA_ERROR,
      ],
      params: editData,
    },
  };
}

// 送出訂單
export function putOrderData(orderingId, paramsData) {
  return {
    [CALL_API]: {
      url: NEWTUBE_API_SERVER + 'Ordering/' + orderingId,
      method: 'PUT',
      headers: {
        functionCode: 'OrderEmp',
        actionCode: 'default',
      },
      types: [
        PUT_ORDERDATA_REQUEST,
        PUT_ORDERDATA_SUCCESS,
        PUT_ORDERDATA_ERROR,
      ],
      params: paramsData,
    },
  };
}

// 取得可訂購人員列表
export function fetchLimitEmployees(orderingId, paramsData) {
  return {
    [CALL_API]: {
      url: NEWTUBE_API_SERVER + `Ordering/${orderingId}/employees/search`,
      method: 'GET',
      types: [
        FETCH_LIMIT_EMPLOYEES_REQUEST,
        FETCH_LIMIT_EMPLOYEES_SUCCESS,
        FETCH_LIMIT_EMPLOYEES_ERROR,
      ],
      params: paramsData,
    },
  };
}

// 放棄訂購
export function postOrderPass(orderingId) {
  return {
    [CALL_API]: {
      url: NEWTUBE_API_SERVER + 'Ordering/' + orderingId + '/Pass',
      method: 'POST',
      headers: {
        functionCode: 'OrderEmp',
        actionCode: 'default',
      },
      types: [
        POST_ORDERPASS_REQUEST,
        POST_ORDERPASS_SUCCESS,
        POST_ORDERPASS_ERROR,
      ],
    },
  };
}

// 取消訂單
export function postOrderCancel(orderingId) {
  return {
    [CALL_API]: {
      url: NEWTUBE_API_SERVER + 'Ordering/' + orderingId + '/Cancel',
      method: 'DELETE',
      headers: {
        functionCode: 'OrderEmp',
        actionCode: 'default',
      },
      types: [
        POST_ORDERCANCEL_REQUEST,
        POST_ORDERCANCEL_SUCCESS,
        POST_ORDERCANCEL_ERROR,
      ],
    },
  };
}

// 刪除訂單
export function deleteOrderData(orderingId) {
  return {
    [CALL_API]: {
      url: NEWTUBE_API_SERVER + 'Ordering/Management/' + orderingId,
      method: 'DELETE',
      headers: {
        functionCode: 'OrderEmp',
        actionCode: 'Manage',
      },
      types: [
        DELETE_ORDERDATA_REQUEST,
        DELETE_ORDERDATA_SUCCESS,
        DELETE_ORDERDATA_ERROR,
      ],
    },
  };
}

// 管理訂單 - 總計結果 - 下載明細
export function getDownloadExcelPaidTotal(OrderingId) {
  const downloadUrl = NEWTUBE_API_SERVER + 'Ordering/Management/TotalOrderItem/DownloadExcel?OrderingId=' + OrderingId;
  const types = [
    GET_DOWNLOADEXCEL_PAIDTOTAL_REQUEST,
    GET_DOWNLOADEXCEL_PAIDTOTAL_SUCCESS,
    GET_DOWNLOADEXCEL_PAIDTOTAL_ERROR,
  ];
  return downloadFile(downloadUrl, types, undefined, 'GET', 'OrderEmp', 'Manage');
}

// 管理訂單 - 收費管理 - 下載明細
export function getDownloadExcelPaid(OrderingId) {
  const downloadUrl = NEWTUBE_API_SERVER + 'Ordering/Management/PaidOrder/DownloadExcel?OrderingId=' + OrderingId;
  const types = [
    GET_DOWNLOADEXCEL_PAID_REQUEST,
    GET_DOWNLOADEXCEL_PAID_SUCCESS,
    GET_DOWNLOADEXCEL_PAID_ERROR,
  ];
  return downloadFile(downloadUrl, types, undefined, 'GET', 'OrderEmp', 'Manage');
}

// 儲存備註
export function putReceivablesNote(orderingId, note = '') {
  return {
    [CALL_API]: {
      url: NEWTUBE_API_SERVER + 'Ordering/Management/PaidOrder/ReceivablesNote?OrderingId=' + orderingId,
      method: 'PUT',
      headers: {
        functionCode: 'OrderEmp',
        actionCode: 'Manage',
      },
      types: [
        PUT_RECEIVABLESNOTE_REQUEST,
        PUT_RECEIVABLESNOTE_SUCCESS,
        PUT_RECEIVABLESNOTE_ERROR,
      ],
      params: {
        receivablesNote: note,
      },
    },
  };
}

// 管理訂單 - 收費管理 - 已付款(可多筆)
export function putOrderIsPay(orderingId, orderArray) {
  return {
    [CALL_API]: {
      url: NEWTUBE_API_SERVER + 'Ordering/Management/PaidOrder/IsPay?OrderingId=' + orderingId,
      method: 'PUT',
      headers: {
        functionCode: 'OrderEmp',
        actionCode: 'Manage',
      },
      types: [
        PUT_ORDERISPAY_REQUEST,
        PUT_ORDERISPAY_SUCCESS,
        PUT_ORDERISPAY_ERROR,
      ],
      params: orderArray,
    },
  };
}

// 管理訂單 - 收費管理 - 取消訂單(可多筆)
export function putOrderCancel(orderingId, orderArray) {
  return {
    [CALL_API]: {
      url: NEWTUBE_API_SERVER + 'Ordering/Management/PaidOrder/Cancel?OrderingId=' + orderingId,
      method: 'DELETE',
      headers: {
        functionCode: 'OrderEmp',
        actionCode: 'Manage',
      },
      types: [
        PUT_ORDERCANCEL_REQUEST,
        PUT_ORDERCANCEL_SUCCESS,
        PUT_ORDERCANCEL_ERROR,
      ],
      params: orderArray,
    },
  };
}



/** WEBPACK FOOTER **
 ** D:/a/1/s/src/containers/App/screens/Tube/screens/Orders/screens/Index/reducers/index.js
 **/